<template>
  <div class="page" id="folders">
    <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
    <mnavbar @menuVisible="menuVisible"></mnavbar>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      background-color="#EBF9FF"
      color="#02B99E"
    >
    </loading>
    <vue-snotify></vue-snotify>
    <div class="decorative-texture top">
      <img src="../../assets/img/texture.png" />
    </div>
    <div class="decorative-texture position-bottom movil-only">
      <img src="../../assets/img/texture.png" />
    </div>
    <section>
      <div class="container">
        <section class="folder-list">
          <div class="container">
            <div class="card">
              <div class="folder-title-container">
                <div class="row align-items-center justify-content-between">
                  <div class="col-auto">
                    <h1 class="title-folder-list">Newsletters</h1>
                  </div>
                  <div class="col-auto col-btn-group">
                    <div class="button-group">
                      <button
                        class="button icon-button tooltip"
                        data-tooltip="Listado"
                        @click="changeType('list')"
                      >
                        <svg viewBox="0 0 11.63 10.6">
                          <g
                            id="Grupo_3"
                            data-name="Grupo 3"
                            transform="translate(-244.91 -1091.59)"
                          >
                            <g id="Grupo_28" data-name="Grupo 28">
                              <rect
                                id="Rectángulo_1052"
                                data-name="Rectángulo 1052"
                                width="11.63"
                                height="1.75"
                                transform="translate(244.91 1091.59)"
                                fill="#00b99e"
                              />
                              <rect
                                id="Rectángulo_1052_copia"
                                data-name="Rectángulo 1052 copia"
                                width="11.63"
                                height="1.75"
                                transform="translate(244.91 1096)"
                                fill="#00b99e"
                              />
                              <rect
                                id="Rectángulo_1052_copia_2"
                                data-name="Rectángulo 1052 copia 2"
                                width="11.63"
                                height="1.78"
                                transform="translate(244.91 1100.41)"
                                fill="#00b99e"
                              />
                            </g>
                          </g>
                        </svg>
                      </button>
                      <button
                        class="button icon-button tooltip"
                        data-tooltip="Cuadrícula Grande"
                        @click="changeType('medium')"
                      >
                        <svg viewBox="0 0 12 11">
                          <g
                            id="Grupo_3_copia"
                            data-name="Grupo 3 copia"
                            transform="translate(-277 -1091)"
                          >
                            <rect
                              id="Rectángulo_1052"
                              data-name="Rectángulo 1052"
                              width="5.16"
                              height="4.59"
                              transform="translate(277 1091)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_2"
                              data-name="Rectángulo 1052 copia 2"
                              width="5.16"
                              height="4.63"
                              transform="translate(277 1097.37)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_3"
                              data-name="Rectángulo 1052 copia 3"
                              width="5.12"
                              height="4.59"
                              transform="translate(283.88 1091)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_3-2"
                              data-name="Rectángulo 1052 copia 3"
                              width="5.12"
                              height="4.63"
                              transform="translate(283.88 1097.37)"
                              fill="#00b99e"
                            />
                          </g>
                        </svg>
                      </button>
                      <button
                        class="button icon-button tooltip"
                        data-tooltip="Cuadrícula Pequeña"
                        @click="changeType('')"
                      >
                        <svg viewBox="0 0 11 11">
                          <g
                            id="Grupo_3_copia_2"
                            data-name="Grupo 3 copia 2"
                            transform="translate(-307 -1091)"
                          >
                            <rect
                              id="Rectángulo_1052_copia_5"
                              data-name="Rectángulo 1052 copia 5"
                              width="3"
                              height="3"
                              transform="translate(307 1099)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_5-2"
                              data-name="Rectángulo 1052 copia 5"
                              width="3"
                              height="3"
                              transform="translate(311 1099)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_5-3"
                              data-name="Rectángulo 1052 copia 5"
                              width="3"
                              height="3"
                              transform="translate(315 1099)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_6"
                              data-name="Rectángulo 1052 copia 6"
                              width="3"
                              height="3"
                              transform="translate(307 1095)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_6-2"
                              data-name="Rectángulo 1052 copia 6"
                              width="3"
                              height="3"
                              transform="translate(311 1095)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_6-3"
                              data-name="Rectángulo 1052 copia 6"
                              width="3"
                              height="3"
                              transform="translate(315 1095)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_7"
                              data-name="Rectángulo 1052 copia 7"
                              width="3"
                              height="3"
                              transform="translate(307 1091)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_7-2"
                              data-name="Rectángulo 1052 copia 7"
                              width="3"
                              height="3"
                              transform="translate(311 1091)"
                              fill="#00b99e"
                            />
                            <rect
                              id="Rectángulo_1052_copia_7-3"
                              data-name="Rectángulo 1052 copia 7"
                              width="3"
                              height="3"
                              transform="translate(315 1091)"
                              fill="#00b99e"
                            />
                          </g>
                        </svg>
                      </button>
                      <button
                        class="button icon-button tooltip"
                        data-tooltip="Crear newsletter"
                        @click="showCloseModal"
                      >
                        <font-awesome-icon
                          icon="folder-plus"
                          style="color: #00b99e; height: 100%"
                        />
                      </button>
                      <button
                        class="button icon-button tooltip"
                        data-tooltip="Refrescar"
                        @click="reload"
                      >
                        <font-awesome-icon
                          icon="sync"
                          style="color: #00b99e; height: 100%"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div
                  :class="['col-4', 'col-sm-3', 'col-md-2', 'folder', typeList]"
                  v-for="item in newsletters"
                  :key="item.index"
                >
                  <newsletter :newsletter="item" ></newsletter>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <modalNewsletter :active="active" :close="showCloseModal" :reload="reload" :edit="false"/>

  </div>
</template>
<script>
import SideMenu from "@/components/sideMenu";
import mnavbar from "@/components/mnavbar";
import carousel from "@/components/carousel";
import index from "./index.vue";
import newsletter from "./components/viewNewsletter.vue";
import modalNewsletter from "./components/modalAgregarnewsletter.vue";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolderPlus,faSearch,faSync } from '@fortawesome/free-solid-svg-icons'

library.add(faSearch)
library.add(faFolderPlus)
library.add(faSync)

export default {
  components: { mnavbar, carousel, SideMenu, index,newsletter,modalNewsletter },
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      isLoading: false,
      menuOn: false,
      newsletters: [],
      typeList: "",
      active:false,
    };
  },
  mounted() {
    this.getNewsletterUser();
  },
  methods: {
    enterFolder(folderKey) {
      this.isLoading = true;
      var params = { from: "carpetas" };
      this.$store.commit("saveBack2", params);

      this.$router.push({
        name: "viewFolder",
        params: { id: folderKey },
      });
    },
    menuVisible(menu) {
      this.menuOn = menu;
    },
    async reload() {
      // this.isLoading = true;
      this.newsletters = [];
      await this.getNewsletterUser();
      // this.isLoading = false
    },
    crearCarpeta() {
      this.show = true;
    },
    changeType(type) {
      this.typeList = type;
    },
    goTo(key) {
      this.$emit("goTo", key);
    },
    async getNewsletterUser() {
      //
      this.isLoading = true;
      var formData = {
        id: this.$store.state.userInfo.id,
      };
      await axios
        .post(
          this.url + "getnewsletteruser",
          formData
        ) //petición
        .then((response) => {
          this.newsletters = response.data.data;
         
        })
        .catch(function (error) {
          console.log(error);
        });
        this.isLoading = false;
    },
    replaceByDefault(e) {
      e.target.src = this.$store.state.defaultFolder;
    },
    getImagen(item){
      var img = item.logo==undefined?this.$store.state.defaultFolder:item.logo;
      return img;
    },
    showCloseModal() {
      this.active = !this.active;     
    },
  },
};
</script>
<style scoped>
.touchpad {
  cursor: pointer;
}

.img-avatar {
  height: 100%;
}

.folder-image .img-avatar {
  position: relative;
}

.folder-image .image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
  border-radius: 100%;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.folder-image :hover .image {
  opacity: 0.2;
}

.folder-image :hover .middle {
  opacity: 1;
}

.text {
  width: 100%;
  padding: 10px;
  color: #062633;
  font-size: 16px;
}
</style>